import { connect } from "react-redux";
import { Results as Component } from "../index";

function mapStateToProps(state, props) {
  return {
    ...props,
    magnifications: state.sorter.magnifications,
    selectedThumbnail: state.sorter.selectedThumbnail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectThumbnail: (magnification) => {
      dispatch({ type: "SELECT_THUMBNAIL", payload: magnification });
    },
  };
}

export const ResultsComparisonMicroscopeRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
